const textEncoder = typeof TextEncoder !== 'undefined' ? new TextEncoder() : null;

/**
 * 计算字符串的 UTF-8 字节长度。
 *
 * @param text - 需要计算的文本片段。
 * @returns 文本片段在 UTF-8 编码下的字节长度。
 */
export const getUtf8ByteLength = (text: string): number => {
    if (textEncoder) return textEncoder.encode(text).length;

    return unescape(encodeURIComponent(text)).length;
};

/**
 * 将 UTF-16 索引转换为 UTF-8 偏移量。
 *
 * @param text - 需要转换的文本片段。
 * @param utf16Index - UTF-16 索引。
 * @returns UTF-8 偏移量。
 */
export const utf16IndexToUtf8Offset = (text: string, utf16Index: number): number =>
    getUtf8ByteLength(text.slice(0, Math.max(0, utf16Index)));

/**
 * 将 UTF-8 偏移量转换为 UTF-16 索引。
 *
 * @param text - 需要转换的文本片段。
 * @param utf8Offset - UTF-8 偏移量。
 * @returns UTF-16 索引。
 */
export const utf8OffsetToUtf16Index = (text: string, utf8Offset: number): number => {
    let bytes = 0;
    let index = 0;

    for (const char of text) {
        const nextBytes = bytes + getUtf8ByteLength(char);
        if (nextBytes > utf8Offset) break;
        bytes = nextBytes;
        index += char.length;
    }

    return index;
};
